import { OptimizationDto } from "#modules/optimizations/infra/computeOptimizations.api";
import { FormatterMaterialParameter } from "shared";

export const getOptimizationMaxPartDimensions = ({
  sheetNestingOptimizationMetadata,
  quoteRequestLines,
}: OptimizationDto): FormatterMaterialParameter => ({
  height: sheetNestingOptimizationMetadata?.height ?? null,
  length: Math.max(0, ...quoteRequestLines.map(({ part }) => part.length ?? 0)),
  width: Math.max(0, ...quoteRequestLines.map(({ part }) => part.width ?? 0)),
});
